import toast from 'react-hot-toast';
import FormSearch from './form-search';
import {useQueryGetExpiredVessels} from '@/api/queries/vessels';
import {useEffect, useState} from 'react';

import {ExpiredData} from '@/types/api';
import moment from 'moment';
import DatatableWithTheme from '@/components/ui/datatableWIthTheme';

import ShipLoading from '@/components/ui/loader/ShipLoading';
import { FileBarChart2 } from 'lucide-react';

type Props = {};

type filterForm = {
    vessel: string;
    startDate: string;
    endDate: string;
};
export default function DetailReportExpired({}: Props) {
    const [filter, setFilter] = useState<filterForm>({
        vessel: '',
        startDate: '',
        endDate: '',
    });

    const {
        error: errorDetailVessel,
        isError: isErrorDetailVessel,
        data: dataDetailVessel,
        isLoading: isLoadingDetailVessel,
        isFetching: isFetchingDetailVessel,
        refetch,
    } = useQueryGetExpiredVessels(filter.startDate, filter.endDate, filter.vessel);

    const onSearch = (value: filterForm) => {
        if (value.startDate === '') {
            toast.error('Start Date is required', {
                position: 'top-center',
            });
            return;
        }

        if (value.endDate === '') {
            toast.error('End Date is required', {
                position: 'top-center',
            });
            return;
        }

        setFilter(value);
    };

    useEffect(() => {
        if (
            filter.startDate !== '' &&
            filter.startDate !== null &&
            filter.endDate !== '' &&
            filter.endDate !== null
        ) {
            refetch();
        }
    }, [filter]);

    const columns = [
        {
            name: 'Vessel Id',
            selector: (row: ExpiredData) => row.vessel_id,
            sortable: true,
            width: 'auto',
        },
        {
            name: 'Vessel Name',
            selector: (row: ExpiredData) => row.vessel_name,
            sortable: true,
            width: 'auto',
        },
        {
            name: 'Expire Date',
            selector: (row: ExpiredData) => row.expire_date,
            sortable: true,
            cell: (row: ExpiredData) => (
                <span
                    className={
                        moment(row.expire_date, 'YYYY-MM-DD HH:mm:ss') < moment() ? 'text-red-500' : ''
                    }
                >
          {row.expire_date}
        </span>
            ),
            width: '200px',
        },
    ];

  return (
    <div className="space-y-6">
      <div className="relative overflow-hidden rounded-2xl border border-gray-200 dark:border-gray-800 bg-gradient-to-r from-brand-600 to-brand-500 text-white shadow-sm">
        <div
          className="absolute inset-0 opacity-20 pointer-events-none"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 20%, rgba(255,255,255,.45), transparent 40%), radial-gradient(circle at 80% 80%, rgba(255,255,255,.25), transparent 45%)",
          }}
        />
        <div className="relative p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="h-12 w-12 shrink-0 rounded-2xl bg-white/15 backdrop-blur flex items-center justify-center ring-1 ring-white/25">
              <FileBarChart2 className="h-6 w-6" />
            </div>
            <div>
              <div className="text-[10px] sm:text-xs uppercase tracking-[0.18em] text-white/70 font-semibold mb-1">
                Fleet intelligence
              </div>
              <h1 className="text-xl sm:text-2xl font-bold tracking-tight">
                Expired Vessel Report
              </h1>
              <p className="text-sm text-white/80 mt-1 max-w-xl">
                Overview of vessels with expired documents and licenses.
              </p>
            </div>
          </div>
        </div>
      </div>

      <FormSearch onSearch={onSearch} type="history"/>

      <div className="bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-800 shadow-sm rounded-2xl p-4 sm:p-6 overflow-x-auto">
        <DatatableWithTheme
          columns={columns}
          progressPending={isLoadingDetailVessel || isFetchingDetailVessel}
          progressComponent={<ShipLoading label="Memuat data kapal..." />}
          data={dataDetailVessel || []}
          paginationPerPage={10}
          pagination
        />
      </div>
    </div>
  );
}
